import Vue, { FunctionalComponentOptions, CreateElement, RenderContext } from 'vue';

export default <FunctionalComponentOptions>{
    functional: true,

    props: {
        sequentialFocus: {
            type: Boolean,
            default: false
        }
    },

    render: function(h: CreateElement, ctx: RenderContext) {
        return h(
            'button', {
                class: ['wok--input-action', ctx.data.staticClass],
                attrs: buttonAttrs(ctx),
                on: ctx.listeners
            }, [
                ctx.slots().default
            ]
        )
    }
}

function buttonAttrs(ctx: RenderContext) {
    return {
        role: 'button',
        type: 'button',
        tabindex: ctx.props.sequentialFocus ? false : '-1',
        ...ctx.data.attrs
    };
}
